module.exports = __webpack_public_path__ + "static/img/slide-2.cb7e335a.jpg";